import React, { type FC, memo, forwardRef, type RefObject } from 'react';
import { type GeneralFieldProps } from '../../../types/Field';
import { FieldName } from '../../../types/CardFieldName';
import { DH } from '../../../utils/DataHook';
import { t } from '../../../utils/i18n';
import { FieldErrorMessage } from '../../FieldErrorMessage';
import { FieldInput } from '../../FieldInput';
import { FieldLabel } from '../../FieldLabel';

export type CardHolderNameProps = GeneralFieldProps;

export const CardHolderName: FC<CardHolderNameProps> = memo(
  forwardRef((props: CardHolderNameProps, ref: RefObject<HTMLInputElement>) => {
    const {
      value,
      isValid,
      isTouched,
      isErrorCanBeShown,
      customInput,

      onChange,
      onBlur,
      onFocus,
      onLabelClick,
    } = props;

    if (!customInput) {
      return (
        <div data-hook={DH.Field.Container.HolderName}>
          <FieldInput
            ref={ref}
            required
            type="text"
            autoComplete="cc-name"
            value={value}
            fieldName={FieldName.HolderName}
            label={t('card.holderName')}
            isTouched={isTouched}
            isValid={isValid}
            isErrorCanBeShown={isErrorCanBeShown}
            errorMessage={t('card.holderName.error')}
            placeholder={t('card.holderName.placeholder')}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </div>
      );
    }

    return (
      <div data-hook={DH.Field.Container.HolderName}>
        <FieldLabel fieldName={FieldName.HolderName} text={t('card.holderName')} onClick={onLabelClick} />
        <FieldInput
          customInput
          ref={ref}
          fieldName={FieldName.HolderName}
          type="text"
          value={value}
          isValid={isValid}
          isTouched={isTouched}
          required
          name="ccname"
          autoComplete="cc-name"
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        {isTouched && !isValid && <FieldErrorMessage fieldName={FieldName.HolderName} />}
      </div>
    );
  }),
);
CardHolderName.displayName = 'CardHolderName';
